import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentsService } from '../providers/payments/payments.service';

@Component({
  selector: 'app-payment-failed',
  templateUrl: './payment-failed.component.html',
  styleUrls: ['./payment-failed.component.scss']
})
export class PaymentFailedComponent implements OnInit {

  paymentData: any;
  paramData: any;
  constructor(public payementservice : PaymentsService, public routes: Router,private route: ActivatedRoute) { 
    let tempData = localStorage.getItem('stripe-payment-user');
    this.paramData = this.route.snapshot.queryParams['ispayament'];
    if(tempData){
      this.paymentData = JSON.parse(tempData);
    }
  }

  ngOnInit(): void {
    this.submitPayment();
  }

  submitPayment(){
		if(this.paymentData){
      this.paymentData['payment_gateway'] = 'Stripe';
      this.paymentData['payment_method'] = 'Card';
      this.paymentData['status'] = 'Failed';
			this.payementservice.savePaymentSuccess(this.paymentData).subscribe(
				(response) => {
					if (response.body.code == 200) {
						localStorage.setItem('stripe-payment-user','');
            setTimeout(()=>{
              this.routes.navigate(['/'])
            },3000);
					}	else {

					}
				},
			);
		}
	}
}
